import { Stack, Tooltip, Typography } from "@mui/material"
import { MeetingStatus, Patient, CalendarSlot, User } from "../../../types"
import { useProposeMeeting } from "./propose-meeting-context"

interface MeetingTimeSlotProps {
    event: CalendarSlot
}

const getDisplayText = (
    event: CalendarSlot,
    compact: boolean,
    patient: Patient | undefined
) => {
    if (patient) {

        if (compact) {
            return patient.displayId
        }

        return `Patient: ${patient.displayId}`
    }

    if (!event.meetingType || event.meetingType === MeetingStatus.Proposed) {
        return "Proposed Timeslot"
    }

    return "Unknown patient"
}

const getTooltipText = (
    event: CalendarSlot,
    patient: Patient | undefined,
    user: User | undefined
) => {

    const isProposed = !event.meetingType || event.meetingType === MeetingStatus.Proposed

    let patientText: string
    if (patient) {
        patientText = `Patient ${patient.displayId}`
    } else {
        patientText = isProposed ?
            "Proposed Timeslot" : "Unknown Patient"
    }

    if (!user?.fullName) {
        return "Proposed Time " + patientText
    }

    if (isProposed) {
        return "Proposed Time " + patientText + ` (User: ${user?.fullName})`
    }

    return "Meeting " + patientText + ` (Creator: ${user?.fullName})`
}


const MeetingTimeslot: React.FC<MeetingTimeSlotProps> = ({
    event,
}) => {

    const { userDictionary, patientDictionary } = useProposeMeeting()

    const duration = event.endTime.getTime() - event.startTime.getTime()
    const compact = duration <= 30 * 60 * 1000

    const user = userDictionary[event.creatorId]
    const patient = event.patientId ? patientDictionary[event.patientId] : undefined

    const isProposed = !event.meetingType || event.meetingType === MeetingStatus.Proposed

    const display = getDisplayText(event, compact, patient)
    const tooltipText = getTooltipText(event, patient, user)

    return (
        <Tooltip title={tooltipText} arrow placement={"right"}>
            <Stack height={"100%"} spacing={2}>
                <Typography>
                    {display}
                </Typography>
                {!compact && isProposed && user && (
                    <Typography>
                        User: {user.fullName}
                    </Typography>)
                }
            </Stack>
        </Tooltip>
    )
}

export default MeetingTimeslot